import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/js/utils';
window.intlTelInput = intlTelInput;
